/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u5_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 10-20% drop is normal and expected. Over 5 minutes your hands tire, concentration dips, and small errors accumulate — all things a 1-minute burst doesn't have time to expose. If the gap is much larger than 20%, it usually points to fatigue or posture rather than a skill problem.`)
};

const es_typing_u5_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una caída del 10-20% es normal y esperada. En 5 minutos tus manos se cansan, la concentración baja y los pequeños errores se acumulan — cosas que un arranque de 1 minuto no tiene tiempo de mostrar. Si la diferencia es mucho mayor al 20%, suele apuntar a fatiga o postura más que a un problema de habilidad.`)
};

const de_typing_u5_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Rückgang von 10-20% ist normal und zu erwarten. Über 5 Minuten ermüden deine Hände, die Konzentration lässt nach, und kleine Fehler summieren sich — alles Dinge, für die ein 1-Minuten-Sprint keine Zeit hat, sich zu zeigen. Ist der Unterschied deutlich größer als 20%, deutet das meist eher auf Ermüdung oder Haltung hin als auf ein Können-Problem.`)
};

const nl_typing_u5_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een daling van 10-20% is normaal en te verwachten. Over 5 minuten raken je handen vermoeid, daalt je concentratie en stapelen kleine fouten zich op — allemaal zaken waar een sprint van 1 minuut geen tijd voor heeft. Is het verschil veel groter dan 20%, dan wijst dat meestal op vermoeidheid of houding in plaats van op een gebrek aan vaardigheid.`)
};

const fr_typing_u5_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une baisse de 10 à 20 % est normale et attendue. Sur 5 minutes, vos mains se fatiguent, la concentration baisse et de petites erreurs s'accumulent — autant de choses qu'un pic d'1 minute n'a pas le temps de révéler. Si l'écart est bien supérieur à 20 %, cela pointe généralement vers la fatigue ou la posture plutôt que vers un problème de compétence.`)
};

const it_typing_u5_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un calo del 10-20% è normale e previsto. Nell'arco di 5 minuti le tue mani si stancano, la concentrazione cala e piccoli errori si accumulano — tutte cose che uno scatto da 1 minuto non ha il tempo di rivelare. Se lo scarto è molto maggiore del 20%, di solito indica stanchezza o postura più che un problema di abilità.`)
};

const pt_br2_typing_u5_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma queda de 10-20% é normal e esperada. Ao longo de 5 minutos, suas mãos cansam, a concentração cai e pequenos erros se acumulam — coisas que uma explosão de 1 minuto não tem tempo de revelar. Se a diferença for muito maior que 20%, geralmente indica cansaço ou postura, e não um problema de habilidade.`)
};

const pt_typing_u5_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma queda de 10-20% é normal e esperada. Ao longo de 5 minutos, as suas mãos cansam-se, a concentração diminui e pequenos erros acumulam-se — coisas que um pico de 1 minuto não tem tempo de revelar. Se a diferença for muito maior do que 20%, geralmente aponta para cansaço ou postura em vez de um problema de competência.`)
};

const ja_typing_u5_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10〜20%の低下は正常で、想定内のことです。5分間続けると手が疲れ、集中力が落ち、小さなミスが積み重なります — これらはすべて、1分間の瞬発力では現れる時間のないものです。差が20%を大きく超える場合は、スキルの問題というより疲労や姿勢が原因であることが多いです。`)
};

const zh_typing_u5_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10-20%的下降是正常且预期的。在5分钟内，您的双手会疲劳，注意力会下降，小错误会不断累积 — 这些都是1分钟的短暂爆发来不及暴露的问题。如果差距远大于20%，通常说明是疲劳或姿势问题，而非技能问题。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u5_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u5_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u5_faq3_a", locale)
	if (locale === "en") return en_typing_u5_faq3_a(inputs)
	if (locale === "es") return es_typing_u5_faq3_a(inputs)
	if (locale === "de") return de_typing_u5_faq3_a(inputs)
	if (locale === "nl") return nl_typing_u5_faq3_a(inputs)
	if (locale === "fr") return fr_typing_u5_faq3_a(inputs)
	if (locale === "it") return it_typing_u5_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u5_faq3_a(inputs)
	if (locale === "pt") return pt_typing_u5_faq3_a(inputs)
	if (locale === "ja") return ja_typing_u5_faq3_a(inputs)
	return zh_typing_u5_faq3_a(inputs)
};